import { testIsNonEmptyString } from '../../../../lib/test-and-assert/test-base';
import { userModalRoute } from './router';
import { projectHelper } from '../../../misc/project-helper';
import { useUserRegisterPaymentModalStore } from '../../../store/modules/user-register-payment-modal-store';
import {satGlobals} from "../../../../qaamgo/sat/helper/sat-globals";

class RegisterPaymentModalHelper {
    get #store() {
        return useUserRegisterPaymentModalStore();
    }

    openOnPage(page) {
        return this.#store.openOnPage(page);
    }

    openLogin() {
        return this.openOnPage(userModalRoute.LOGIN);
    }

    openRegister() {
        return this.openOnPage(userModalRoute.REGISTER);
    }

    openContactUs() {
        return this.openOnPage(userModalRoute.CONTACT_US_FORM);
    }

    openUpgrade() {
        if (satGlobals.isMultipleProductsEnabled()) {
            return this.openOnPage(userModalRoute.REGISTER_PRODUCT_CREDITS_SELECT);
        }
        if (satGlobals.isCreditsInAllSatsEnabled()) {
            return this.openOnPage(userModalRoute.REGISTER_PRODUCT_CREDITS_SELECT);
        }
        return this.openOnPage(userModalRoute.REGISTER_PLAN_SELECT);
    }

    openOnlyProAndUltimate() {
        this.#store.setOnlyProAndUltimate(true);

        return this.openOnPage(userModalRoute.REGISTER_PRODUCT_CREDITS_SELECT);
    }

    openForPricingFree() {
        this.#store.setSkipPayment(true);

        return this.openRegister();
    }

    openForPricingPremium(data) {
        this.#store.setSkipPlanSelect(true);

        this.#store.setSelectedBilling(data?.billing ?? null);
        this.#store.setSelectedPlan(data?.plan ?? 'individual');
        this.#store.setSelectedProduct(data?.product ?? 'pro');
        this.#store.setSelectedSize(data?.size ?? null);

        return this.openOnPage(userModalRoute.REGISTER_CHOOSE_BILLING);
    }

    openForPayment(data) {
        this.#store.setSelectedBilling(data?.billing ?? null);
        this.#store.setSelectedPlan(data?.plan ?? 'individual');
        this.#store.setSelectedProduct(data?.product ?? 'pro');
        this.#store.setSelectedQuota(data?.quota ?? null);

        return this.openOnPage(userModalRoute.REGISTER_CHOOSE_PAYMENT);
    }

    isOpen() {
        return testIsNonEmptyString(this.#store.getOpenPage);
    }

    isSubmitting() {
        return this.#store.getSubmitting;
    }
}

if (!global.gRegisterPaymentModalHelper) {
    global.gRegisterPaymentModalHelper = new RegisterPaymentModalHelper();
}

/**
 * @type {RegisterPaymentModalHelper}
 */
const registerPaymentModalHelper = global.gRegisterPaymentModalHelper;

export { registerPaymentModalHelper };
